























































import { assignToTask, removeFromTask } from '@/api/system'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
enum NotificationAction {
  Done,
  Read,
  Assign
}

enum NotificationType {
  OrderPlaced = 1,
  StockLow = 2,
  IncomingMail = 3
}
interface Notification {
  type: string
  actions: number[]
  id: number
  dbTypeId: NotificationType
  active: boolean
  employees: {
    id: number
    permissionlevel: number
    name: {
      short: string
      full: string
      color: string
    }
  }[]
  orderId?: number // for OrderPlaced Notifications
}
@Component({
  name: 'card',
  components: {}
})
export default class extends Vue {
  // @Prop({ required: true }) icon: string
  @Prop({ required: true }) title: string
  @Prop({ required: true }) notifications: Notification[]
  // @Prop({ required: true }) value: string

  async removeSelfFromJob(notification: Notification) {
    await removeFromTask(notification.id)
    this.$store.dispatch('loadNotifications')
  }
  detailedView(notification: Notification) {
    switch (notification.dbTypeId) {
      case NotificationType.OrderPlaced:
        this.$router.push({ path: `/order/summary/${notification.orderId}` })
        break

      default:
        break
    }
  }
  actions(notification: Notification) {
    // find self in employees
    if (this.$store.state.user != undefined && notification.employees != undefined) {
      const selfFound = notification.employees.find(empl => {
        return empl.id == this.$store.state.user.id
      })
      const assignIndex = notification.actions.findIndex(val => {
        return val == NotificationAction.Assign
      })

      if (assignIndex != -1 && selfFound != undefined) return notification.actions.splice(assignIndex, 1)
      else return notification.actions
    }
  }
  async executeAction(action: number, notificationId: number) {
    switch (action) {
      case NotificationAction.Done:
        break

      case NotificationAction.Read:
        break

      case NotificationAction.Assign:
        await assignToTask(notificationId)
        this.$store.dispatch('loadNotifications')
        break

      default:
        break
    }
  }
  getButtonName(action: number) {
    switch (action) {
      case NotificationAction.Done:
        return 'Abschließen'

      case NotificationAction.Read:
        return 'Lesen'

      case NotificationAction.Assign:
        return 'Zuweisen'

      default:
        return '500'
    }
  }
  get oldNotifications() {
    return this.notifications.filter(not => {
      return !not.active
    })
  }
  get newNotifications() {
    return this.notifications.filter(not => {
      return not.active
    })
  }
}
